import { createSelector } from 'reselect'
import getSlidesList from 'views/google_slides/helpers/slides_list'

const externalSlidesSelector = (state, icon) => {
	const slideIndex = state.external.slides.findIndex(
		slide => (slide.icon && slide.icon.id === icon.id)
	)

	let externalSlide = null
	if (slideIndex !== -1) {
		externalSlide = state.external.slides[slideIndex]

		const slidesList = getSlidesList()
		const slide = slidesList.find(slide => (slide.id === externalSlide.slideTypeId))
		const iconVersions = icon.versions

		return {
			slideExternalId: externalSlide.slideExternalId,
			imageUrl: [
				iconVersions.preview || iconVersions.original || iconVersions.scrubber_image,
				slide.overlay,
			],
		}
	}
	return externalSlide
}

export default createSelector(
	[ externalSlidesSelector ],
	externalSlide => externalSlide
)
